import { SourceData } from '@/components/control/TableSelectBox'

export const MORTGAGE_BOND_TYPE_BASIC: SourceData = { value: 'BASIC', name: '근저당' }
export const MORTGAGE_BOND_TYPE_TRUST: SourceData = { value: 'TRUST', name: '신탁 담보' }
export const MORTGAGE_BOND_TYPE_LIST: SourceData[] = [ MORTGAGE_BOND_TYPE_BASIC, MORTGAGE_BOND_TYPE_TRUST ]

export const MORTGAGE_PERSONAL_TYPE_CEO: SourceData = { value: 'CEO', name: '대표이사' }
export const MORTGAGE_PERSONAL_TYPE_STOCK: SourceData = { value: 'STOCK', name: '최대 주주' }
export const MORTGAGE_PERSONAL_TYPE_NOBODY: SourceData = { value: 'NOBODY', name: '없음' }
export const MORTGAGE_PERSONAL_TYPE_OTHER: SourceData = { value: 'OTHER', name: '기타' }
export const MORTGAGE_PERSONAL_TYPE_LIST: SourceData[] = [ MORTGAGE_PERSONAL_TYPE_CEO, MORTGAGE_PERSONAL_TYPE_STOCK ]

